import { Window } from 'ng-chat';

export class Emergency {
    public videocallId: any;
    public chat: Window;
    public processed: boolean;
    public status: string;
    public videoRequested: boolean;
    public chatRequested: boolean;
    public videoEnabled: boolean;
    public chatEnabled: boolean;

    constructor(
        public emergencyId: string,
        public userId: string
    ) {
        this.processed = false;
        this.status = 'CREATING';
        this.videoRequested = false;
        this.chatRequested = false;
        this.videoEnabled = false;
        this.chatEnabled = false;
    }
}
